import React, { useState } from 'react';
import './MaterialFilter.css';

interface MaterialFilterProps {
	onFilterChange: (startDate: string, endDate: string) => void;
	exportButton?: React.ReactNode;
}

const MaterialFilter: React.FC<MaterialFilterProps> = ({ onFilterChange, exportButton }) => {
	const [startDate, setStartDate] = useState<string>('');
	const [endDate, setEndDate] = useState<string>('');

	const handleFilterChange = () => {
		onFilterChange(startDate, endDate);
	};

	return (
		<div className="material-filter">
			<div className="filter-material">
				<label htmlFor="startDate">Начальная дата:</label>
				<input
					type="date"
					id="startDate"
					value={startDate}
					onChange={(e) => setStartDate(e.target.value)}
				/>
			</div>
			<div className="filter-material">
				<label htmlFor="endDate">Конечная дата:</label>
				<input
					type="date"
					id="endDate"
					value={endDate}
					onChange={(e) => setEndDate(e.target.value)}
				/>
			</div>
			<button 
				className="filter-button"
				onClick={handleFilterChange}
			>
				Применить фильтр
			</button>
			{exportButton ? <div style={{ marginLeft: 'auto' }}>{exportButton}</div> : null}
		</div>
	);
};

export default MaterialFilter;
